// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3Iec6","filesListContainer":"PosDisputesFiles_filesListContainer__1EJaS","filesButton":"PosDisputesFiles_filesButton__bRFP4"};